import React from "react";
import Table from "./Table/index";

export default function Audio() {
  return (
    <div>
      <Table />
    </div>
  );
}
